module.exports = __webpack_public_path__ + "img/22.8b3bc942.jpg";